import React, { useMemo } from 'react';

import { Platform, Pressable } from 'react-native';

import { useTranslation } from 'react-i18next';

import CheckmarkIcon from 'assets/images/svgs/ico_checkmark.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    isSelected: boolean;
    label: string;
    onSelect: () => void;
    testID: string;
    backgroundColor: string;
};

const {
    ACCESSIBILITY: {
        ACCESSIBILITY_GENERAL_TAPP_TWICE,
        ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB,
    },
} = LANGUAGE_KEYS;

const AgeRowItem = ({
    isSelected,
    label,
    onSelect,
    testID,
    backgroundColor,
}: Props) => {
    const { t } = useTranslation();

    const accessibilityLabel = useMemo(
        () =>
            `${label} ${isWeb ? t(ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB) : ''}`,
        [t],
    );

    return (
        <Pressable
            style={[
                styles.itemContainer,
                isSelected && {
                    backgroundColor,
                },
            ]}
            onPress={onSelect}
            testID={testID}
            accessibilityRole="button"
            accessibilityLabel={accessibilityLabel}
            {...(Platform.OS === 'ios' && {
                accessibilityHint: t(ACCESSIBILITY_GENERAL_TAPP_TWICE),
            })}
        >
            <Text
                bold={isSelected}
                category={ETextCategory.body1}
                color={isSelected ? ETextColor.black : ETextColor.neutral}
            >
                {label}
            </Text>
            {isSelected ? (
                <CheckmarkIcon
                    fill={isSelected ? COLOR.background : COLOR.NEUTRAL}
                />
            ) : null}
        </Pressable>
    );
};

export default AgeRowItem;
